<template>
    <div>
        <div
            v-if="allowedDays !== null"
            class="kgr-inputAddon"
        >
            <input
                type="text"
                readonly
                :value="displayValue"
                :placeholder="$t('datepicker.placeholder')"
                class="kgr-input"
                :class="{'displayOnly': displayOnly, 'is-invalid': invalid, 'readonly-by-allowed-days': true}"
                @input="input"
                @blur="blur"
                @change="change"
                @keyup.enter="$emit('enter')"
            />
            <div
                v-if="allowedDays !== null && value !== null && !displayOnly"
                class="kgr-inputAddon__addon"
                @click="() => input(null)"
            >
                <kgr-icon-delete small />
            </div>
        </div>

        <input
            v-else
            type="text"
            :readonly="displayOnly"
            :value="displayValue"
            :placeholder="$t('datepicker.placeholder')"
            class="kgr-input"
            :class="{'displayOnly': displayOnly, 'is-invalid': invalid}"
            @input="input"
            @blur="blur"
            @change="change"
            @keyup.enter="$emit('enter')"
        />
        <span v-if="displayOnly">{{ displayValue }}</span>
        <div
            v-if="dataError != null || error != null"
            class="kgr-color kgr-color--error"
        >
            {{ dataError ?? error }}<br />
        </div>
    </div>
</template>

<script>
import IconDelete from '../../icon/IconDelete.vue';
import KgrDate from '../../../../js/date/Date.js';
import moment from 'moment';

export default {
    components: {
        'kgr-icon-delete': IconDelete
    },
    props: {
        value: {
            type: KgrDate,
            required: false,
            default: null,
        },
        showOnInit: {
            type: Boolean,
            required: false,
            default: false,
        },
        displayOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowedDays: {
            type: Array,
            required: false,
            default: null,
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        minDate: {
            type: KgrDate,
            required: false,
            default: null
        },
        maxDate: {
            type: KgrDate,
            required: false,
            default: null
        },
    },
    data() {
        return {
            momentDisplayFormat: 'DD.MM.YYYY',
            inputElement: null,
            invalid: false,
            invalidInputValue: null,
            dataError: null,
        }
    },
    computed: {
        displayValue() {
            if (this.invalid) {
                return this.invalidInputValue;
            }
            if (this.value === null) {
                return null;
            }
            return this.value.format(this.momentDisplayFormat)
        }
    },
    mounted() {
        this.inputElement = $('input', this.$el)[0];
        let allowedDays = this.allowedDays;
        $(this.inputElement).datepicker({
            beforeShowDay: function (date) {
                if (allowedDays === null) {
                    return [true, '', ''];
                }
                return [allowedDays.find(d => date.getDate() === d) != null, '', ''];
            },
            dateFormat: this._mapMomentToDatePicker(this.momentDisplayFormat),
            onSelect: () => {
                this.change();
                this.input();
            }
        });
        if(this.minDate !== null) {
            $(this.inputElement).datepicker('option', 'minDate', new Date(this.minDate.toIso8601()));
        }
        if(this.maxDate !== null) {
            $(this.inputElement).datepicker('option', 'maxDate', new Date(this.maxDate.toIso8601()));
        }

        this.dataError = this.error;

        if (this.showOnInit) {
            $(this.inputElement).datepicker('show');
        }
    },
    watch: {
        minDate: function() {
            $(this.$el).datepicker('option', 'minDate', this.minDate ? new Date(this.minDate) : null);
        },
        maxDate: function() {
            $(this.$el).datepicker('option', 'maxDate', this.maxDate ? new Date(this.maxDate) : null);
        }
    },
    methods: {
        input() {
            this.emit(this.inputElement.value, 'input');
        },
        blur() {
            this.emit(this.inputElement.value, 'blur');
        },
        change() {
            this.emit(this.inputElement.value, 'change');
        },
        emit(value, event) {
            if (value === '' || value === null) {
                this.invalid = false;
                this.invalidInputValue = null;
                this.dataError = null;
                this.$emit(event, null);
                if (event === 'input') {
                    this.$nextTick(() => {
                        this.$emit('post-input', null);
                    });
                }
                return;
            }

            const momentDate = moment(value, this.momentDisplayFormat, true)
            this.invalid = !momentDate.isValid();
            if (this.invalid) {
                this.invalidInputValue = value;
                this.dataError = this.$t('Das Datum ist ungültig.');
                this.$emit('error');
            } else if (momentDate.isBefore(moment('01.01.1900', this.momentDisplayFormat, true))) {
                this.invalid = true;
                this.invalidInputValue = value;
                this.dataError = this.$t('Das Datum muss nach dem 01.01.1900 liegen.');
                this.$emit('error');
            } else {
                this.invalidInputValue = null;
                this.dataError = null;
                let newDate = new KgrDate(momentDate.year(), momentDate.month() + 1, momentDate.date());
                this.$emit(event, newDate);
                if (event === 'input') {
                    this.$nextTick(() => {
                        this.$emit('post-input', newDate);
                    });
                }
            }
        },
        _mapMomentToDatePicker(momentFormat) {
            switch (momentFormat) {
                case 'DD.MM.YYYY':
                    return 'dd.mm.yy';
            }
            console.error('not supported moment format. add mapping to get rid of this error.')
        }
    },
}
</script>
<style scoped>
.displayOnly {
    display: none;
    border: none;
    background-color: transparent;
    cursor: default;
    color: var(--kgr-text-color)
}
.readonly-by-allowed-days {
    cursor: default;
    color: var(--kgr-text-color) !important;
}
</style>
